<template>
  <v-flex xs12>
    <v-card>
      <v-flex xs12 px-4 pt-4 pb-2 v-if="err">
        <v-alert type="error" :value="true">{{err}}</v-alert>
      </v-flex>
      <v-layout row wrap align-center justify-space-between class="px-3 pt-3 pb-3">
        <div>
          <datetime
            :phrases="{ ok: $lang.actions.ok, cancel: $lang.actions.cancel}"
            v-model="data.startDate"
            type="datetime"
            :placeholder="$lang.actions.startDate"
            class="datetime-btn primary--text mx-2"
          />
          <datetime
            :phrases="{ ok: $lang.actions.ok, cancel: $lang.actions.cancel}" 
            v-model="data.endDate" 
            type="datetime" 
            :placeholder="$lang.actions.endDate" 
            class="datetime-btn primary--text mx-2" 
          />            
        </div>
        <v-text-field
          v-if="show"
          class="min-w max-w mx-2"
          v-model="search"
          append-icon="search"
          :label="$lang.labels.search"
          hide-details
        />
      </v-layout>
      <v-layout row wrap class="px-2">
        <v-flex xs12 sm6 md4 lg3 px-3>
          <v-autocomplete
            v-model="data.sourceSystem"
            :items="sources"
            :label="$lang.labels.sourceSystem"
            clearable
            hide-details
          />
        </v-flex>
        <v-flex xs12 sm6 md4 lg3 px-3>
          <v-autocomplete
            v-model="data.action"
            :items="actions"
            :label="$lang.header.action"
            clearable
            hide-details
          />
        </v-flex>
        <v-flex xs12 sm6 md4 lg3 px-3>
          <v-text-field
            v-model="data.url"
            :label="$lang.labels.url"
            clearable
            hide-details
          />
        </v-flex>
        <v-flex xs12 sm6 md4 lg3 px-3 class="radio-input">
          <p>{{$lang.labels.auditDirection}}:</p>
          <v-radio-group v-model="data.auditDirection" row hide-details>
            <v-radio :label="$lang.labels.all" :value="null" color="primary"/>
            <v-radio :label="$lang.labels.incoming" value="incoming" color="primary"/>
            <v-radio :label="$lang.labels.outgoing" value="outgoing" color="primary"/>
          </v-radio-group>
        </v-flex>
      </v-layout>
      <v-layout row wrap align-end class="px-3 pb-3">
        <v-btn class="primary mx-2 my-0" @click="showAudit()">{{$lang.actions.showAudit}}</v-btn>
      </v-layout>
      <v-data-table
        v-if="show"
        :headers="headers"
        :items="auditLogs"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="[50, 100, 250, 500, { text:'All' , value: -1 }]"
      >
        <v-progress-linear height="6" slot="progress" color="primary" indeterminate />
        <template slot="items" slot-scope="props">
          <td class="min-w">{{ formatDate(props.item.createdOn) }}</td>
          <td class="min-w-lg">
            {{ props.item.createdByFullName }} 
            <small class="d-block">{{ props.item.createdBy }}</small>
          </td>
          <td>
            {{ props.item.sourceSystem }}
            <small class="d-block">{{ props.item.systemVersion }}</small>
          </td>
          <td>{{ props.item.companyId }}</td>
          <td>{{ props.item.action }}</td>
          <td>{{ props.item.url }}</td>         
          <td>{{ props.item.auditDirection }}</td>         
          <td class="min-w-lg">
            {{ props.item.shortData }}
            <v-btn 
              v-if="props.item.shortData" 
              class="mx-0" 
              flat small 
              @click="showData(props.item.data)">
              ...
            </v-btn>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="warning" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
    </v-card>
    <v-dialog v-if="auditModal" v-model="auditModal" max-width="1200">
      <audit-modal :auditData="auditData" @close="auditModal = false"/>
    </v-dialog>
  </v-flex>
</template>

<script>
  import {DateTime} from 'luxon';

  export default {
    components: {
      auditModal: () => import('../modals/AuditModal'),
    },
    data() {
      return {
        err: '',
        search: '',
        menu: false,
        menu2: false,
        show: false,
        auditModal: false,
        loading: false,
        auditData: null,
        sources: ['MOON', 'SUN_WEB' ],
        actions: ['AccountActivate', 'AccountCreate', 'AccountDeactivate', 'AccountFetchRoles', 'AccountGet', 'AccountGetAll', 'AccountManageRoles', 'AccountResetPassword', 'AccountRoles', 'AccountUpdate', 'AppResourceActivate', 'AppResourceCreate', 'AppResourceDeactivate', 'AppResourceGet', 'AuditGetAll', 'CallerIdServerCreate', 'CallerIdServerDeactivate', 'CallerIdServerFetchById', 'CallerIdServerGetAll', 'CatalogActivate', 'CatalogCreate', 'CatalogGet', 'CatalogGetAll', 'CatalogGetCatalogVersionsForCompany', 'CatalogGetWebShopViewsForCatalog', 'CompanyActivate', 'CompanyAddAllConfiguration', 'CompanyCreate', 'CompanyDeactivate', 'CompanyGet', 'CompanyGetAll', 'CompanyUpdate', 'CompanyValidate', 'CorporationCreate', 'CorporationDeactivate', 'CorporationGetAll', 'CorporationGetById', 'CorporationUpdate', 'DiscountRuleActivate', 'DiscountRuleCreate', 'DiscountRuleDeactivate', 'DiscountRuleGet', 'DiscountRuleGetAll', 'DiscountRuleUpdate', 'DomainResourceActivate', 'DomainResourceCreate', 'DomainResourceDeactivate', 'DomainResourceGetAll', 'DomainResourceGetAllForACompany', 'DomainResourceGetById', 'DomainResourceUpdate', 'FetchAllPrintersForACompany', 'FetchLicenseTypes', 'FetchSystemVersion', 'GenerateMonthlyAggregatedLicenseUsage', 'GenerateMonthlyLicenseUsage', 'GetAllCurrencies', 'GetSystemCurrencies', 'GetSystemFetchPrinterCategories', 'GetSystemPrintTemplateTypes', 'LicenseActivate', 'LicenseCreate', 'LicenseDeactivate', 'LicenseGet', 'LicenseGetAll', 'LicenseUsageGet', 'LicenseUsageGetAll', 'LogMigrationData', 'MarkMoonConfigAsSync', 'MonthlyLicenseUsageGetForYearAndMonth', 'MoonBackupCreate', 'MoonBackupCreateNonCompanySpecific', 'MoonConfigUpdateGetById', 'MoonInstanceGet', 'MoonInstanceGetAll', 'MoonRegister', 'MoonReRegister', 'PlanetConfigUpdateGetById', 'PricingGroupInvoiceGenerate', 'PricingGroupInvoiceGetById', 'PrinterActivate', 'PrinterCategoryGetAll', 'PrinterCreate', 'PrinterDeactivate', 'PrinterGet', 'PrinterGetAll', 'PrinterGetAllPrinterCategories', 'PrinterUpdate', 'PrintServerActivate', 'PrintServerCreate', 'PrintServerDeactivate', 'PrintServerFetchById', 'PrintServerGetAll', 'PrintServerUpdate', 'PrintTemplateActivate', 'PrintTemplateCreate', 'PrintTemplateDeactivate', 'PrintTemplateGetAll', 'PrintTemplateGetById', 'PrintTemplateGetForCompany', 'ReportGetById', 'SunUserLogin', 'SunUserLogout', 'SystemLogsGetAll', 'SystemWebSpaceFetchProperties', 'SystemWebSpaceFetchTemplates', 'SystemWebSpaceFetchTypes', 'TableActivate', 'TableCategoryActivate', 'TableCategoryCreate', 'TableCategoryDeactivate', 'TableCategoryGetAll', 'TableCategoryGetById', 'TableCategoryUpdate', 'TableCreate', 'TableCreateMultiple', 'TableDeactivate', 'TableGetAll', 'TableGetById', 'TableUpdate', 'WebShopFetchPostalCodeDistance', 'WebShopResourceActivate', 'WebShopResourceCreate', 'WebShopResourceDeactivate', 'WebShopResourceGetById', 'WebShopResourceUpdate', 'WebShopResourceUpdatePaymentGatewayPassword', 'WebShopResourceUpdatePublicKey', 'WebSpaceActivate', 'WebSpaceCreate', 'WebSpaceDeactivate', 'WebSpaceGetAll', 'WebSpaceGetById', 'WebSpaceUpdate'],
        data: {
          startDate: DateTime.local().minus({ hours: 4 }).toISO(),
          endDate: DateTime.local().plus({ hours: 2 }).toISO(),
          url: null,
          action: null,
          sourceSystem: null,
          auditDirection: null,
        },
        auditLogs: [],
        pagination: {
          sortBy: 'createdOn', 
          descending: true,
        },
        headers: [
          { text: this.$lang.labels.created, value: 'createdOn', align: 'left' },
          { text: this.$lang.header.createdBy, value: 'createdByFullName', align: 'left' },
          { text: this.$lang.header.sourceVersion, value: 'sourceSystem', align: 'left' },
          { text: this.$lang.labels.companyId, value: 'companyId', align: 'left' },
          { text: this.$lang.header.action, value: 'action', align: 'left' },
          { text: this.$lang.labels.url, value: 'url', align: 'left' },
          { text: this.$lang.labels.auditDirection, value: 'auditDirection', align: 'left' },
          { text: this.$lang.labels.data, value: 'data', align: 'left' },
        ],
      };
    },
    watch: {
      err(val) {
        if (val !== '') {
          setTimeout(() => { this.err = ''; }, 5000);
        }
      },
    },
    methods: {
      formatDate(date) {
        return DateTime.fromISO(date).toFormat('yyyy-MM-dd HH:mm');
      },
      showData(data) {
        this.auditData = data;
        this.auditModal = true;
      },
      showAudit() {
        this.loading = true;
        this.show = true;
        const data = this.data;
        data.url = data.url === '' ? null : data.url;
        data.action = data.action === '' ? null : data.action;
        data.sourceSystem = data.sourceSystem === '' ? null : data.sourceSystem;
        data.auditDirection = data.auditDirection === '' ? null : data.auditDirection;
        this.$http.post('audit', data)
          .then((res) => {
            if (res.body.status !== 'Success') {
              this.err = res.body.statusText;
              return;
            }
            this.auditLogs = res.body.details.map((current) => {
              const audit = current;
              audit.shortData = audit.data.slice(0, 63);
              return audit;
            });
            if (this.auditLogs !== 0) {
              this.loading = false;
            }
          }, (err) => {
            this.loading = false;
            this.err = err.body.statusText || err.body.message;
          });
      }
    },
  };
</script>

<style lang="scss" scoped>
  .btn {
    min-width: auto !important;
  }
  .radio-input {
    padding-top: 4px;
    p {
      padding-bottom: 0;
      margin-bottom: 0;
      color: rgba(0,0,0,.54);
      font-size: 16px;
    }
    .input-group {
      padding-top: 0 !important;
    }
  }
</style>



// WEBPACK FOOTER //
// AuditLog.vue?c468335e